import st from "@/styles/Modals.module.scss";
import ModalLayout from "@/ui/modals/ModalLayout.tsx";
import DashboardClass from "@/utils/dashboard_class.ts";
import WritePinFields from "@/ui/WritePinFields.tsx";
import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import CreditApplicationInterface from "@/types_and_interfaces/credit_application_interface.ts";
import ResendCounter from "@/ui/ResendCounter.tsx";
import {pin_value, sign_contract_otp_interval, succeded_application} from "@/atoms/common.ts";
import useIntervals from "@/hooks/intervals.ts";
import {useAtom} from "jotai/index";
import CommonClass from "@/utils/common.ts";
import eventEmitter from "@/utils/event_emmiter_instance.ts";
import useLoans from "@/hooks/loans.ts";
import {useNavigate} from "react-router-dom";
import LoginLoader from "@/ui/LoginLoader.tsx";
import useAuth from "@/hooks/auth.ts";

interface Props {
    data:any
    data_handler(x:any):void
    is_cr_line?:boolean
}

const SignContractOTPModal:React.FC<Props> = ({data, data_handler, is_cr_line}) => {
    
    const [error, set_error] = useState<boolean>(false)
    const {t} = useTranslation()
    const intervals_hook = useIntervals(sign_contract_otp_interval)
    // const typed_data = data !== undefined ? data as CreditApplicationInterface : {}
    const [pin] = useAtom(pin_value);
    const [reqLoad, setReqLoad] = useState<boolean>(false)
    const loans = useLoans()
    const navigate = useNavigate()
    const [, set_succeded_application] = useAtom(succeded_application)
    const auth = useAuth()
    const user = auth.current_user()
    
    const typed_data = data as CreditApplicationInterface
    
    const handleSetReqLoad = (x:boolean) => {
        setReqLoad(x);
    };
    
    const step1 = async () => {
        let data = {
            "id": typed_data.id,
            "uid": typed_data.urn,
            "is_credit_line": is_cr_line ? true : undefined
        }
        
        const enabled = await loans.signContractSt1(data);
        
        if(typeof user !== undefined) {
            if (!enabled) {
                eventEmitter.emit(CommonClass.CustomEvents.update_snackbar, "error", t("error_message"));
            } else {
                intervals_hook.setIntervalHandler()
                eventEmitter.emit(CommonClass.CustomEvents.set_resend_interval, false)
            }
        }
    }
    
    const sign = async () => {
        
        setReqLoad(true)
        
        try {
            let data = {
                "id": typed_data.id,
                "uid": typed_data.urn,
                "is_credit_line": is_cr_line ? true : undefined,
                "otp": pin.join("")
            }
            
            let enable = await  loans.signContractSt2(data)
            
            if(enable) {
                set_succeded_application(typed_data)
                navigate(is_cr_line ? DashboardClass.dashboard_routes.SuccessOpenCrLine + `/${typed_data.urn}` : DashboardClass.dashboard_routes.Success);
            } else {
                set_error(true)
            }
        } catch (e){
            set_error(true)
        }
        
        setReqLoad(false)
    }
    
    useEffect(() => {
        
        if(pin.every(str => str.length > 0)){
            sign()
        }
    }, [pin]);
    
    useEffect(() => {
        
        eventEmitter.on(CommonClass.CustomEvents.set_req_load, handleSetReqLoad)
        
        
        return () => {
            intervals_hook.clear_interval()
            eventEmitter.off(CommonClass.CustomEvents.set_req_load, handleSetReqLoad)
        }
        
    }, []);
    
    return (
        <ModalLayout
            className={st.sign_contract_otp_modal}
            // open={true}
            open={Boolean(data)}
            innerClassName={st.sign_contract_otp_modal_inner}
            on_close_state={() => {
                data_handler(undefined)
            }}
        >
            
            <>
                <div className={st.top}>
                    <div className={st.heading}>
                        {t("insert_code")}
                        
                        <div className={st.info}>
                        
                            <span className={st.inf_text}>
                                {t("code_sent_to_nr")}
                            </span>
                            
                            <span className={st.phone_nr}>
                                {typed_data?.phone || user?.phone || ""}
                            </span>

                        </div>
                        
                        <WritePinFields
                            error={error}
                            className={st.pin}
                        />
                    
                    </div>
                    
                    <ResendCounter
                        className={st.resend_otp}
                        onClick={step1}
                        interval_atom={sign_contract_otp_interval}
                    />
                </div>
                
                {reqLoad &&
                    <LoginLoader/>
                }
            </>
        
        </ModalLayout>
    )
}

export default SignContractOTPModal